import { render, staticRenderFns } from "./TestEditor.vue?vue&type=template&id=c897a1d2&scoped=true"
import script from "./TestEditor.vue?vue&type=script&lang=js"
export * from "./TestEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c897a1d2",
  null
  
)

export default component.exports